import { BoundTextField } from "lib/@components/binding/bound-components"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useScheduleCodeAvailabilityCheck } from "../lib/use-schedule-code-availability-check"

export function ScheduleCodeField() {
    const [code] = useBoundValue("code")
    const { target, refresh } = useBoundContext()
    const codeError = useScheduleCodeAvailabilityCheck({ code, onAvailabilityChange: setCodeUnavailable })

    return (
        <BoundTextField
            field="code"
            yup="string.required.trim.max(50, 'Code must be 50 characters or fewer')"
            autoFocus
            {...(codeError && { error: true, helperText: codeError })}
        />
    )

    function setCodeUnavailable(unavailable) {
        target._codeUnavailable = unavailable
        refresh()
    }
}
